import React from 'react'
import { assets } from '../assets/assets'


const Footer = () => {
  return (
    <div>
        <div className ='flex flex-col sm:grid grid-cols-[3fr_1fr_1fr] gap-14 my-3 mt-40 text-sm px-3 '>
            
            <div>
                <img src={assets.wmlogo} className='mb-5 w-32 animate-sine' alt =""/>
                <p className ='w-full md:w-2/3 text-gray-100'></p>
            </div>

            <div>
                <p className ='text-center text-xl font-bold mb-5 text-white border-b border-white'>LINKS</p>
                <ul className ='flex flex-col gap-1 text-white'>
                    <a href='https://github.com/walkmoody' target = "_blank" rel="noopener noreferrer">
                        <li className='border-2 rounded-full text-center cursor-pointer [background-color:#010101] font-bold hover:bg-gray-600'>Github</li>
                    </a>

                    <a href='https://www.linkedin.com/in/walkermoody/' target = "_blank" rel="noopener noreferrer">
                        <li className='border-2 rounded-full text-center cursor-pointer [background-color:#010101] font-bold hover:bg-gray-600'>Linkedin</li>
                    </a>
                </ul>
            </div>

            <div>
                <p className ='onest-norm text-xl font-bold mb-5 text-white text-center border-b border-white'>GET IN TOUCH</p>
                <ul className ='border-2 rounded-full text-center flex flex-col gap-1 text-white [background-color:#010101] font-bold px-4'>
                    <li>(512)-277-0615</li>
                    <li>moodywalkertx@gmail.com</li>
                    <li></li>
                </ul>
            </div>

        </div>
        <div className = 'my-7 py-3 px-5'>
            <hr/>
        </div>
        <div className='flex justify-center py-1'>
            <p className = 'text-sm text-center text-gray-300'>Copyright 2025 @ Walker Moody - All Right Reserved.</p>
        </div>
        <div className='py-5'></div>
    </div>
  )
}

export default Footer
